import { render, staticRenderFns } from "./ResourceAvailabilityWrapper.vue?vue&type=template&id=1da73921&scoped=true"
import script from "./ResourceAvailabilityWrapper.vue?vue&type=script&lang=js"
export * from "./ResourceAvailabilityWrapper.vue?vue&type=script&lang=js"
import style0 from "./ResourceAvailabilityWrapper.vue?vue&type=style&index=0&id=1da73921&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da73921",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer})
